// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1lqud","footer":"ModalUpdate_footer__271ln"};